<template>
  <div>
    <div class="watchlist-summary">
      <span class="watchlist-summary__title">
        Фильтр:
      </span>
      
      <span class="watchlist-summary__item">
        {{ listSummary }}
      </span>
    </div>
    
    <list-items-loadable 
      v-slot="{ item }" 
      :items="itemsToSee"
    >
      <document-snippet-medium
        #before
        :document="item.document"
        :class="{ _marked: markedAsReadDocIds[item.document.id] }"
      >
        <button-watch
          :active="true"
          @click="$emit('button-watch-click', item)"
        />

        <label
          class="checkbox__label watchlist__unread"
          :title="unreadCheckboxTitle(markedAsReadDocIds[item.document.id])"
        >
          <span
            v-if="item.unread"
            class="checkbox__icon"
            :class="{ _checked: markedAsReadDocIds[item.document.id] }"
            @click="$emit('toggle-read-mark', item)"
          >
            <svg class="icon-checkbox" width="16" height="16">
              <use xlink:href="#checkbox" />
            </svg>
            
            <svg class="icon-checkbox_checked" width="16" height="16">
              <use xlink:href="#checkbox-checked" />
            </svg>
          </span>
        </label>
      </document-snippet-medium>
    </list-items-loadable>
    
    <list-paginator
      :items-total="itemsTotal"
      :items-per-page="itemsPerPage"
      :items-per-page-options="[20, 50, 100]"
      items-per-page-label="Документов на странице:"
      @update="handlePaginatorUpdate"
    />
  </div>
</template>

<script>
import ButtonWatch from '@@/document/DocumentToolbar/ButtonWatch';
import DocumentSnippetMedium from '@@/shared/snippets/Snippet_Medium';
import ListItemsLoadable from '@@/shared/list/ListItemsLoadable';
import ListPaginator from '@@/shared/list/ListPagination';

export default {
  components: {
    ButtonWatch,
    DocumentSnippetMedium,
    ListItemsLoadable,
    ListPaginator
  },

  props:{    
    events: {
      required: true
    },
    items: {
      required: true
    },
    filterUnread: {
      default: () => true
    },
    curEventId: {
      default: () => null
    },
    curPeriodId: {
      default: () => null
    },
    itemsPerPage: {
      default: () => 20
    },
    itemsTotal: {
      required: true
    },
    itemsOffset: {
      default: () => 0
    },
    markedAsReadDocIds: {
      default: () => {return {}}
    }
  },

  computed: {
    itemsToSee() {
      return this.filterUnread ? this.items.filter(i => i.unread) : this.items;
    },
    curEvent() {
      return this.events.find(event => event.id === this.curEventId);
    },
    curPeriod() {
      return this.curEvent
        ? this.curEvent.periods.find(period => period.id === this.curPeriodId)
        : null;
    },
    listSummary() {
      if (this.filterUnread) {
        let text = 'Непрочтённые';

        if (this.curPeriod) {
          text +=
            ', ' +
            (this.curPeriod.isFuture
              ? this.curEvent.futureCaption
              : this.curEvent.pastCaption);

          text += ' ' + this.curPeriod.name.toLowerCase();
        }
        return text;
      }
      return 'Все';
    }
  },

  methods: {
    unreadCheckboxTitle(id) {
      return `Отметить как ${id ? 'не' : ''}прочитанное`;
    },
    handlePaginatorUpdate(obj) {
      this.$emit('paginator-update', obj);
    }
  }
};
</script>
